module.exports = __webpack_public_path__ + "img/send.61e12a51.svg";